import {
    Box, Button, Flex, Spacer, Text
} from "@chakra-ui/react";
import * as React from 'react';
import {FC, useEffect, useState} from "react";
import api from "../../services/api";
import PiperzStudioIcon from "../../styles/icons/PiperzStudioIcon";
import RedirectIcon from "../../styles/icons/RedirectIcon";
import SessionListTodayCard from "./SessionListTodayCard";
import Footer from "../../components/Footer";
import MenuSessions from "../../components/MenuSessions";
import { getSessions, saveSessions } from "../../services/db";

interface SessionProps {}

const SessionListToday: FC<SessionProps> = () => {

    const [sessions, setSessions] = useState<any[]>([]);
    const [filter, setFilter] = useState<object>({});
    const [load, setLoad] = useState(false);

    const fetchSessions = async () => {
        setLoad(true);
        try {
            if (navigator.onLine) {
                const response = await api.post(`/provider/sessions`, { filter, today: true });
                if (response.status === 200) {
                    setSessions(response.data);
                    await saveSessions(response.data);
                }
            } else {
                const cachedSessions = await getSessions();
                if (cachedSessions) {
                    setSessions(cachedSessions);
                }
            }
        } catch (error) {
            const cachedSessions = await getSessions();
            if (cachedSessions) {
                setSessions(cachedSessions);
            }
        } finally {
            setLoad(false);
        }
    };

    useEffect(() => {
        fetchSessions();
    }, [filter]);

    return (
        <>
            <Box justifyContent={'center'} m={'4'}>
                <MenuSessions/>

                <Flex mt={4} bg={'#00D99D'} borderRadius={'2xl'} flexDirection={'column'}>
                    <Flex justifyContent={'space-between'} px={'3'}>
                        <PiperzStudioIcon />
                        <Button bg={'white'} borderRadius={'3xl'} p={'0'} shadow={'lg'} mt={3}>
                            <RedirectIcon />
                        </Button>
                    </Flex>
                    <Text color={'white'} ml={'28'} mr={'1'} fontSize={'sm'} textAlign={'right'}>
                        Utilize a versão desktop para a entrega das produções. V2.0
                    </Text>
                </Flex>

                <Spacer mt={'9'}/>

                <Flex flexDirection={'column'} gap={'6'} mb={24}>
                    {sessions.map(session => (
                        <SessionListTodayCard key={session.id} session={session}/>
                    ))}
                </Flex>
            </Box>
            <Footer />
        </>
    );
};

export default SessionListToday;
